import { SectionError, SectionLoading } from '@/components/section-state';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { formatCurrency, formatDecimal, formatNumber, getQualityGapCount } from './formatting';
import type { UsageClinicRow } from './types';

export const UsageClinicTable = ({
  clinics,
  isLoading,
  isError,
  error,
  onRetry,
  onClinicFilter,
}: {
  clinics: UsageClinicRow[];
  isLoading: boolean;
  isError: boolean;
  error: unknown;
  onRetry: () => void;
  onClinicFilter: (clinic: UsageClinicRow) => void;
}) => (
  <Card>
    <CardHeader>
      <CardTitle>Stofur</CardTitle>
      <CardDescription>Kostnaður og atburðir eftir stofu</CardDescription>
    </CardHeader>
    <CardContent>
      {isLoading && <SectionLoading label="Sæki stofur" />}
      {isError && <SectionError title="Stofur hlóðust ekki" error={error} onRetry={onRetry} />}
      {!isLoading && !isError && clinics.length === 0 && (
        <div className="flex min-h-28 items-center justify-center rounded-md border border-dashed text-muted-foreground text-sm">
          Engin gögn fundust fyrir valið tímabil.
        </div>
      )}
      {!isLoading && !isError && clinics.length > 0 && (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Stofa</TableHead>
              <TableHead className="text-right">Heildarkostnaður</TableHead>
              <TableHead className="text-right">Hljóðmínútur</TableHead>
              <TableHead className="text-right">Atburðir</TableHead>
              <TableHead className="text-right">Gagnagöt</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {clinics.map((clinic) => {
              const name = clinic.clinic_name || 'Óþekkt stofa';
              return (
                <TableRow key={clinic.clinic_id ?? name}>
                  <TableCell>
                    <Button
                      type="button"
                      variant="ghost"
                      className="-ml-3 justify-start"
                      aria-label={`Sía eftir ${name}`}
                      onClick={() => onClinicFilter(clinic)}
                    >
                      {name}
                    </Button>
                  </TableCell>
                  <TableCell className="text-right">{formatCurrency(clinic.total_cost_usd)}</TableCell>
                  <TableCell className="text-right">{formatDecimal(clinic.audio_minutes, 1)}</TableCell>
                  <TableCell className="text-right">{formatNumber(clinic.total_events)}</TableCell>
                  <TableCell className="text-right">{formatNumber(getQualityGapCount(clinic))}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      )}
    </CardContent>
  </Card>
);
